import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["inputRef", "onChange", "inputSize", "onOpenChange"];
import CRMPropertyDateInput from 'customer-data-properties/date/CRMPropertyDateInput';
import { MomentTypes } from 'customer-data-properties/date/MomentTypes';
import { getTransferrableProps } from '../utils/getTransferrableProps';
import { memo, useCallback, useState } from 'react';
import { DATE } from 'customer-data-objects/property/PropertyTypes';
import useComponentMountMetric from '../metrics/useComponentMountMetric';
import { useProperty } from '../v2/hooks/useProperty';
import { usePropertyValue } from '../v2/hooks/usePropertyValue';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import useGetValidatedDateOptions from '../hooks/useGetValidatedDateOptions';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyInputDate = _ref => {
  let {
      inputRef,
      onChange,
      inputSize,
      onOpenChange
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  useComponentMountMetric('PropertyInputDate');
  const [isInitialValue, setIsInitialValue] = useState(true);
  const property = useProperty();
  const value = usePropertyValue();
  const dateOptions = useGetValidatedDateOptions(value);
  const handleChange = useCallback(evt => {
    const {
      target: {
        value: newValue
      }
    } = evt;
    if (typeof onChange === 'function') {
      // CRMPropertyDateInput (UIDateInput)'s onChange sends `number | null`; convert to `string | null`
      onChange(newValue == null ? syntheticEvent(null) : syntheticEvent(String(newValue)));
      if (isInitialValue === true) {
        setIsInitialValue(false);
      }
    }
  }, [onChange, isInitialValue]);
  return /*#__PURE__*/_jsx(CRMPropertyDateInput, Object.assign({}, getTransferrableProps(rest), {
    value: value,
    momentType: MomentTypes.USER,
    onChange: handleChange,
    onOpenChange: onOpenChange,
    inputRef: inputRef,
    inputSize: inputSize,
    type: property.type === DATE ? 'date' : undefined,
    dateDisplayHint: property.dateDisplayHint
    // The previously saved value may have fallen out of validation
    // so we don't want to show the error until the user has entered a new value
    ,
    error: isInitialValue ? false : undefined,
    min: dateOptions.min,
    max: dateOptions.max,
    disabledValues: dateOptions.disabledValues,
    onCalendarPageChange: dateOptions.onCalendarPageChange
  }));
};
export default /*#__PURE__*/memo(PropertyInputDate);